import getCopilotCatchUpStore from '../store/store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import type { TableView } from 'owa-mail-list-store';

/***
 * This function checks if the emails should be filtered based on a folder wide experiment API call.
 * The current catchup digest allows for need scheduling to be filtered in 2 ways - with or without running a folder wide API call.
 * If the catchup store asks us to use the LLM prompt AND to apply the prompt to incoming messages, we do NOT use the folder wide experiment API call.
 * We run a prompt on a single message instead
 *
 * @param tableView - The table view of the mailbox.
 * @returns A boolean indicating whether the emails should be filtered based on the experiment API call.
 */
export const shouldFilterEmailsWithExperimentAPICall = (tableView: TableView): boolean => {
    const copilotCatchUpStore = getCopilotCatchUpStore(getMailboxInfo(tableView));
    const isBackgroundProcessingEnabled =
        copilotCatchUpStore.shouldUsePrompt &&
        copilotCatchUpStore.shouldApplyPromptToIncomingMessages;

    return !isBackgroundProcessingEnabled;
};
